module.exports = {"230603001":"龙凤街道","230603002":"兴化街道","230603007":"卧里屯街道","230603008":"东光街道","230603009":"三永街道","230603100":"龙凤镇","230603580":"高新区农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230603.json
// module id = 732
// module chunks = 0